import { track } from '@tldraw/tldraw'
import Styles from './Toolbar.module.scss'
import { ToolbarProps } from './Types'
import { TabsToggleButton } from './TabsToggleButton'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ButtonGroup } from './ButtonGroup'
import { HistoryButtonGroup } from './HistoryButtonGroup'
import { Section } from './Section'
import { Tabs } from 'components/Design/Tabs/Tabs'
import { useAbility } from '@casl/react'
import { AbilityContext } from 'components/Can'
import { UserRole } from 'types'
import { SubjectType } from 'utils/caslAbility'
import { useCallback, useMemo } from 'react'
import { useWorkspace } from 'hooks/useWorkspace'

const AsideSpacer = observer(() => {
  const { designStore } = useRootStore()

  return <div style={{ width: designStore?.isTabOpen ? 312 + 10 : 0 }} />
})

const Toolbar = track(({ editor }: ToolbarProps) => {
  const { designStore } = useRootStore()
  const file = designStore?.file
  const workspace = useWorkspace(file?.workspace.id || null)
  const ability = useAbility(AbilityContext)

  const authedFile = useMemo(() => {
    return {
      role: workspace?.role || UserRole.UNAUTHED,
      permissions: file?.permissions,
      __caslSubjectType__: SubjectType.DESIGN,
    }
  }, [file?.permissions, workspace?.role])

  const can: typeof ability.can = useCallback(
    (action, subject) => {
      return ability.can(action, subject)
    },
    [ability],
  )

  // Need to render an empty container to account for the missing bottom padding of the TopBar
  if (!can('edit', authedFile)) return <div className={Styles.emptyToolbar} />

  return (
    <div className={Styles.toolbarContainer} data-testid="design-toolbar">
      <div className={Styles.toolbar}>
        <Section>
          <HistoryButtonGroup editor={editor} />
        </Section>

        {file && (
          <Section>
            <Tabs file={file} />
          </Section>
        )}

        <Section>
          <ButtonGroup>
            <TabsToggleButton />
          </ButtonGroup>
        </Section>
      </div>
      <AsideSpacer />
    </div>
  )
})

export { Toolbar }
